import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	customInputFile: {
		border: `1px solid ${colors.gray[200]}`,
		borderRadius: theme.shape.borderRadius,
		padding: theme.spacing(2.5, 1.5, 2.5, 1.5)
	},
	customInputFileError: {
		border: `1px solid ${theme.palette.error.main}`,
		borderRadius: theme.shape.borderRadius,
		padding: theme.spacing(2.5, 1.5, 2.5, 1.5)
	},
	customInputFileLabel: {
		marginRight: 10,
		whiteSpace: "nowrap",
		maxWidth: "400px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "inline-block"
	},
	tabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			backgroundColor: colors.gray[200]
		}
	},
	tab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14
	},
	tabIndicator: {
		backgroundColor: colors.getPrimaryColor()
	},
	disableTab: {
		color: colors.gray[400],
		boxShadow: "none",
		opacity: 0.7
	},
	tabArea: {
		display: "flex",
		gap: 12
	},
	textareaLineNumbers: {
		backgroundColor: colors.gray[200],
		"& > div": {
			paddingLeft: theme.spacing(0.5),
			paddingRight: theme.spacing(0.5)
		},
		"& textarea": {
			textAlign: "center",
			color: colors.gray[50]
		},
		"& fieldset": {
			border: 0
		}
	},
	textAreaScrollable: {
		"& textarea": {
			overflow: "auto !important"
		}
	}
}))

export default useStyles
